import { render, staticRenderFns } from "./SectorInfo.vue?vue&type=template&id=0992eaff&scoped=true&"
import script from "./SectorInfo.vue?vue&type=script&lang=js&"
export * from "./SectorInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectorInfo.vue?vue&type=style&index=0&id=0992eaff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992eaff",
  null
  
)

export default component.exports